/* Move the Judge.me all-reviews bar into the sticky media column, under the
   trust box.

   Why move rather than render our own: the widget is server-rendered by a
   Judge.me app block with live rating data and its own click bindings. A second
   copy would either show stale numbers or fight the app's JS for the same
   selectors. Moving the real node keeps one source of truth.

   Judge.me injects/rehydrates late, so this retries via MutationObserver rather
   than assuming the node exists at DOMContentLoaded. */
(function () {
  var MAX_MS = 12000;

  function place() {
    var slot = document.querySelector('[data-tk-reviews-slot]');
    if (!slot || slot.dataset.filled === 'true') return true;

    var widget = document.querySelector('.jdgm-all-reviews-text');
    if (!widget || slot.contains(widget)) return !!widget;

    // Remember the section it came from so we can collapse the empty shell.
    var section = widget.closest('.shopify-section');

    slot.appendChild(widget);
    slot.dataset.filled = 'true';

    if (section && !section.querySelector('.jdgm-widget')) {
      section.setAttribute('data-tk-emptied', 'true');
    }
    return true;
  }

  /* Mobile only: the product title reads better between the gallery and the
     trust box than below the whole media column. Done in the DOM rather than
     with CSS ordering - see the note in tailkind-tokens.css. */
  function placeTitle() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var title = document.querySelector('.product__info-container > .product__title');
    var trust = document.querySelector('.product__media-wrapper .tailkind-trust-bar');
    if (!title || !trust || title.dataset.tkMoved === 'true') return;
    trust.parentNode.insertBefore(title, trust);
    title.dataset.tkMoved = 'true';
  }
  placeTitle();

  if (place()) { placeTitle(); return; }

  var started = Date.now();
  var observer = new MutationObserver(function () {
    placeTitle();
    if (place() || Date.now() - started > MAX_MS) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Backstop for the case where the node is already present but mutations stop.
  setTimeout(function () { place(); observer.disconnect(); }, MAX_MS);
})();
